import styled from "styled-components"

const PrevButtonStyled = styled.button`
  background-color: ${(props) =>
    props.theme.a_color_gradients.a_dark} !important;
  color: black;
`

const NextButtonStyled = styled.button`
  background-color: ${(props) =>
    props.theme.a_color_gradients.a_dark} !important;
  color: black;
`

const CarouselOpenerButton = styled.button`
  background-color: ${(props) =>
    props.theme.a_color_gradients.a_dark} !important;
`

export { PrevButtonStyled, NextButtonStyled, CarouselOpenerButton }
